import { toast } from 'react-toastify';

import useSyncMutation from './useSyncMutation';

import { useLanguageContext } from '~providers';
import { postPaymentRequest } from '~services';
import { LoginDirectRequest, MutateContext } from '~types';

export const useMutationLoginDirect = ({
  shouldToast = true,
  onSuccessCallback,
  onErrorCallback,
}: MutateContext & {
  onSuccessCallback?: () => void;
  onErrorCallback?: (errorMsg: string) => void;
}) => {
  const { lt } = useLanguageContext();

  return useSyncMutation(
    (request: LoginDirectRequest) => {
      return postPaymentRequest({
        path: 'api/campus-card/login/direct',
        data: request,
      });
    },
    {
      onError() {
        const message = lt(
          'text.hooks.useMutationLoginDirect.error',
          'Login failed. Please check your username or password',
        );

        if (shouldToast) toast.error(message);
        onErrorCallback?.(message);
      },
      onSuccess() {
        if (shouldToast) {
          toast.success(
            lt(
              'text.hooks.useMutationLoginDirect.success',
              'Campus card linked successfully',
            ),
          );
        }
        onSuccessCallback?.();
      },
    },
  );
};
